import styled from "styled-components";

// Sections
export const Section = styled.section`
  margin-bottom: 40px;
`;

export const SectionTitle = styled.h2`
  font-size: 22px;
  color: #2c3e50;
  margin-bottom: 10px;
`;

export const SectionContent = styled.div`
  background-color: #fff;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
`;

// Cards
export const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 20px;
`;

export const Card = styled.div`
  background-color: #eef3f8;
  padding: 16px;
  border-radius: 10px;
  box-shadow: inset 0 0 0 1px #dce3eb;
  h4 {
    margin: 0 0 6px;
    font-size: 18px;
    color: #1c2c40;
  }
  p {
    margin: 0 0 4px;
    color: #546e7a;
  }
  span {
    font-size: 13px;
    color: #78909c;
  }
`;

export const DashboardLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
`;

export const TopSection = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
`;

export const BottomSection = styled.div`
  display: grid;
  grid-template-columns: 3fr 2fr;
  gap: 20px;
`;

export const DashboardCard = styled(Card)`
  height: 100%;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  display: flex;
  flex-direction: column;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
  }

  h3 {
    margin: 0 0 15px;
    font-size: 18px;
    color: #1c2c40;
  }

  .card-count {
    font-size: 32px;
    font-weight: 700;
    color: #00b894;
    margin-bottom: 8px;
  }

  .card-description {
    font-size: 14px;
    color: #546e7a;
    margin-top: auto;
  }
`;

export const CardContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const ApplicationsTable = styled.table`
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    padding: 12px 15px;
    text-align: left;
    border-bottom: 1px solid #e0e0e0;
  }

  th {
    font-weight: 600;
    color: #1c2c40;
    background-color: #f9fafb;
  }

  tr:last-child td {
    border-bottom: none;
  }

  tr:hover td {
    background-color: #f4f7fa;
  }

  .status {
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
  }

  .status-applied {
    background-color: #e3f2fd;
    color: #1976d2;
  }

  .status-interview {
    background-color: #e8f5e9;
    color: #388e3c;
  }

  .status-shortlisted {
    background-color: #fff8e1;
    color: #f57c00;
  }
`;

export const InterviewCard = styled(Card)`
  margin-bottom: 15px;
  border-left: 4px solid #00b894;

  .interview-date {
    font-size: 14px;
    color: #00b894;
    font-weight: 600;
    margin-bottom: 8px;
  }

  .interview-title {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 6px;
  }

  .interview-company {
    font-size: 14px;
    color: #546e7a;
    margin-bottom: 6px;
  }

  .interview-time {
    font-size: 13px;
    color: #78909c;
    display: flex;
    align-items: center;
  }
`;

export const InterviewsContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 500px;
  overflow-y: auto;
`;
